/* Fiche produit personnalisable : champs, aperçu en direct, fichier d'impression, ajout au panier. */
const f_label = (f) => (f.type === 'image' || f.type === 'images' ? 'Merci d’ajouter vos photos.' : `Merci de remplir le champ « ${f.label} ».`);
const PAGE_LABELS = ['Couverture', 'Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'];
const PAGE_NAMES = ['Couverture', 'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre', 'Dernière page'];
if (!customElements.get('ideo-product')) {
  customElements.define(
    'ideo-product',
    class extends HTMLElement {
      async connectedCallback() {
        const D = window.IdeoDesigns;
        if (!D || !D.DESIGNS[this.dataset.design]) return;
        this.design = this.dataset.design;
        this.format = this.dataset.format;
        this.def = D.DESIGNS[this.design];
        let defaults = {};
        try {
          defaults = JSON.parse(this.querySelector('[data-defaults]').textContent) || {};
          if (typeof defaults === 'string') defaults = JSON.parse(defaults);
        } catch (e) {}
        // texte saisi dans le studio de l'accueil (?texte=…) → champ principal
        const hero = new URLSearchParams(location.search).get('texte');
        const heroField = this.def.fields.find((f) => f.hero);
        this.values = {};
        this.productDefaults = defaults;
        this.def.fields.forEach((f) => (this.values[f.key] = defaults[f.key] || f.default));
        // pack « à offrir aussi » : personnalisation reprise de la fiche jumelle (?perso={"prenoms": "…"})
        try {
          const params = new URLSearchParams(location.search);
          const perso = JSON.parse(params.get('perso') || 'null');
          // panier : &carry=prenoms,annee = seuls champs repris (jumeau du pack : le rôle « Papy » reste celui de cette fiche)
          const carry = params.has('carry') ? params.get('carry').split(',').filter(Boolean) : null;
          if (perso) this.def.fields.forEach((f) => {
            if (carry && !carry.includes(f.key)) return;
            if (typeof perso[f.key] === 'string' && f.type !== 'image' && f.type !== 'images') this.values[f.key] = perso[f.key].slice(0, f.max || 200);
          });
        } catch (e) {}
        if (hero && heroField) this.values[heroField.key] = hero.slice(0, heroField.max);

        // formats (affiche seule / encadrée / toile) : { "valeur d'option": { uid, print, style } }
        const readJson = (sel, fallback) => {
          try {
            let v = JSON.parse(this.querySelector(sel)?.textContent || 'null');
            if (typeof v === 'string') v = JSON.parse(v);
            return v || fallback;
          } catch (e) {
            return fallback;
          }
        };
        this.formats = readJson('[data-formats]', {});
        this.mugMockups = readJson('[data-mug-mockups]', null);
        // t-shirt, body : rendus Gelato du vêtement vierge par style (couleur / modèle)
        this.garmentMockups = readJson('[data-garment-mockups]', null);
        // sweat à capuche : masque des cordons, redessinés devant l'impression
        if (this.dataset.garmentMask) {
          this.garmentMask = new Image();
          this.garmentMask.addEventListener('load', () => this.draw());
          this.garmentMask.src = this.dataset.garmentMask;
        }
        this.variants = readJson('[data-variants]', []);
        this.selectVariant(Number(this.dataset.variant));
        this.querySelectorAll('[data-variant-id]').forEach((btn) =>
          btn.addEventListener('click', () => {
            const before = this.shotStyle;
            this.selectVariant(Number(btn.dataset.variantId));
            this.draw();
            this.dispatchEvent(new CustomEvent('ideo:edit')); // galerie : retour à l'aperçu du modèle choisi
            if (this.shotStyle !== before) this.revealPreview();
          })
        );
        // plusieurs options (t-shirt : couleur × taille) : on garde les autres options et on cherche la variante correspondante
        const pick = (idx, value) => {
          const cur = this.variants.find((x) => x.id === Number(this.dataset.variant)) || this.variants[0];
          const want = [...(cur.options || [])];
          want[idx] = value;
          // combinaison absente (coupe femme sans sable…) : la variante la plus proche, en gardant la valeur choisie
          const score = (x) => (x.options || []).reduce((n, o, i) => n + (o === want[i] ? 1 : 0), 0);
          const v = this.variants.find((x) => (x.options || []).every((o, i) => o === want[i]))
            || this.variants.filter((x) => (x.options || [])[idx] === value).sort((a, b) => score(b) - score(a))[0];
          if (v) {
            const before = this.shotStyle;
            this.selectVariant(v.id);
            this.draw();
            this.dispatchEvent(new CustomEvent('ideo:edit')); // galerie : retour à l'aperçu du modèle choisi
            if (this.shotStyle !== before) this.revealPreview();
          }
        };
        this.pickOption = pick;
        this.querySelectorAll('[data-opt-index]').forEach((btn) =>
          btn.addEventListener('click', () => pick(Number(btn.dataset.optIndex), btn.dataset.optValue))
        );
        // longue liste (modèle de téléphone) : liste déroulante
        this.querySelectorAll('[data-opt-select]').forEach((sel) =>
          sel.addEventListener('change', () => pick(Number(sel.dataset.optSelect), sel.value))
        );

        this.buildFields();
        this.buildPack();
        this.canvas = this.querySelector('[data-canvas]');
        this.loadSamples();
        const mockupSrc = { mug: this.dataset.mockup, calendar: this.dataset.mockupCalendar, tote: this.dataset.mockupTote, tshirt: this.dataset.mockupTshirt, body: this.dataset.mockupBody, sweat: this.dataset.mockupSweat, enfant: this.dataset.mockupEnfant, gourde: this.dataset.mockupGourde, coque: this.dataset.mockupCoque, tableau: this.dataset.mockupTableau, brode: this.dataset.mockupBrode }[this.format];
        if (this.format === 'card') this.buildCardUI();
        if (this.def.livre) this.buildLivreUI();
        if (this.def.pages && this.format === 'calendar') {
          // vue « Page » : rendu Gelato du calendrier vierge (spirale, crochet)
          if (this.dataset.calendarPage) {
            this.spiral = new Image();
            this.spiral.addEventListener('load', () => this.draw());
            this.spiral.src = this.dataset.calendarPage;
          }
          this.buildCalendarUI();
        }
        if (mockupSrc) {
          // on dessine tout de suite, puis de nouveau quand la photo du produit est chargée
          this.mockup = new Image();
          this.mockup.addEventListener('load', () => this.draw());
          this.mockup.src = (this.format === 'mug' && this.mugMockups && this.mugMockups[this.shotStyle])
            || (this.garmentMockups && this.garmentMockups[this.shotStyle]) || mockupSrc;
        }
        // illustrations aquarelle du design : aperçu chargé avant le premier dessin, redessin à chaque arrivée
        window.addEventListener('ideo:art', () => this.draw());
        await Promise.all([D.fontsReady(this.design), D.prepare ? D.prepare(this.design) : null]);
        this.draw();
        // redessine quand l'aperçu devient visible ou change de taille (onglet en arrière-plan, rotation…)
        new ResizeObserver(() => this.draw()).observe(this.canvas || this);
        this.querySelector('[data-form]').addEventListener('submit', (e) => {
          e.preventDefault();
          this.addToCart();
        });
        this.showEta();
        this.setupSticky();
        // toute modification du client ramène la galerie sur l'aperçu en direct
        const edit = () => this.dispatchEvent(new CustomEvent('ideo:edit'));
        this.querySelector('[data-form]').addEventListener('input', edit);
        this.querySelector('[data-form]').addEventListener('change', edit);
        this.querySelector('[data-pages]')?.addEventListener('click', edit);
      }

      /** Date de livraison estimée : aujourd'hui + N jours ouvrés (hors samedi et dimanche). */
      showEta() {
        const el = this.querySelector('[data-eta]');
        if (!el) return;
        const add = (n) => {
          const d = new Date();
          while (n > 0) {
            d.setDate(d.getDate() + 1);
            if (d.getDay() !== 0 && d.getDay() !== 6) n--;
          }
          return d;
        };
        const a = add(Number(el.dataset.min)), b = add(Number(el.dataset.max));
        const f = (d, month) => d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', ...(month ? { month: 'long' } : {}) });
        const sameMonth = a.getMonth() === b.getMonth();
        el.innerHTML = `Commandé aujourd'hui, livré entre le <strong>${f(a, !sameMonth)}</strong> et le <strong>${f(b, true)}</strong>`;
        el.hidden = false;
      }

      /** Barre d'achat collante (mobile) : visible quand le bouton du formulaire est hors de l'écran. */
      setupSticky() {
        const bar = this.querySelector('[data-sticky]');
        const add = this.querySelector('[data-add]');
        if (!bar || !add || !('IntersectionObserver' in window)) return;
        new IntersectionObserver(([e]) => {
          bar.hidden = e.isIntersecting;
        }).observe(add);
        bar.querySelector('[data-sticky-add]').addEventListener('click', () => {
          add.scrollIntoView({ behavior: 'smooth', block: 'center' });
          this.querySelector('[data-form]').requestSubmit();
        });
      }

      /** Mobile : l'aperçu est au-dessus des choix ; si l'apparence change (couleur, modèle…) et qu'il est
          plus qu'à moitié hors de l'écran, on remonte jusqu'à lui (sous l'en-tête collant). Pas pour une simple taille. */
      revealPreview() {
        const stage = this.querySelector('.ideo-pdp__stage');
        if (!stage || !window.matchMedia('(max-width: 749px)').matches) return;
        const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 64;
        const r = stage.getBoundingClientRect();
        const visible = Math.min(r.bottom, innerHeight) - Math.max(r.top, header);
        if (visible > r.height / 2) return;
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: scrollY + r.top - header - 8, behavior: smooth ? 'smooth' : 'auto' });
      }

      /** Applique le format choisi : prix affiché, référence Gelato, fichier d'impression et style d'aperçu. */
      selectVariant(id) {
        const v = this.variants.find((x) => x.id === id) || this.variants[0];
        if (!v) return;
        this.dataset.variant = v.id;
        // clé de ideo.formats : « Couleur / Taille » pour les produits à deux options, sinon la valeur de l'option
        const f = this.formats[(v.options || []).join(' / ')] || this.formats[v.option] || {};
        this.printFormat = f.print || this.format;
        this.shotStyle = f.style;
        // textile foncé (noir, marine) : le design passe en encre claire, dans l'aperçu comme dans le fichier d'impression
        if (this.values) this.values._dark = !!f.dark;
        // mug : rendu Gelato du modèle choisi (blanc, intérieur coloré, magique)
        if (this.format === 'mug' && this.mockup) {
          const urls = this.mugMockups || {};
          const src = urls[f.style] || urls.blanc;
          if (src && this.mockup.src !== src) this.mockup.src = src;
          const note = this.querySelector('[data-model-note]');
          if (note) note.hidden = f.style !== 'magique';
        }
        // t-shirt, body : rendu Gelato de la couleur / du modèle choisi
        if (this.mockup && this.garmentMockups) {
          const src = this.garmentMockups[f.style] || Object.values(this.garmentMockups)[0];
          if (src && this.mockup.src !== src) this.mockup.src = src;
        }
        if (this.format === 'sweat' || this.format === 'enfant') {
          const note = this.querySelector('[data-model-note]');
          if (note) note.hidden = !/^cap-/.test(f.style || '');
        }
        // coque : rendu Gelato de la coque vierge du modèle choisi (fine / renforcée × téléphone)
        if (this.format === 'coque' && f.style) {
          const base = this.mockup ? this.mockup.src : this.dataset.mockupCoque;
          const src = (base || '').replace(/coque-gelato-[a-z0-9-]+\.jpg/, `coque-gelato-${f.style}.jpg`);
          if (this.mockup && src && this.mockup.src !== src) this.mockup.src = src;
          else if (!this.mockup) this.dataset.mockupCoque = src;
        }
        // tableau photo : rendu Gelato du support choisi (toile, cadre, plexi × taille × orientation)
        if (this.format === 'tableau' && f.style) {
          const base = this.mockup ? this.mockup.src : this.dataset.mockupTableau;
          const src = (base || '').replace(/tab-gelato-[a-z0-9-]+\.jpg/, `tab-gelato-${f.style}.jpg`);
          if (this.mockup && src && this.mockup.src !== src) this.mockup.src = src;
          else if (!this.mockup) this.dataset.mockupTableau = src;
        }
        if (this.def && this.def.livre && this.livreFiles) {
          this.values._page = Math.min(this.values._page || 0, this.livrePages() / 2);
          this.renderLivreGrid();
        }
        if (f.uid) this.dataset.gelato = f.uid;
        if (this.syncPack) this.syncPack();
        this.querySelectorAll('[data-price]').forEach((el) => (el.textContent = v.price));
        this.querySelectorAll('[data-variant-id]').forEach((b) => {
          const on = Number(b.dataset.variantId) === v.id;
          b.setAttribute('aria-pressed', on);
          b.setAttribute('aria-checked', on);
        });
        this.querySelectorAll('[data-opt-index]').forEach((b) => {
          const on = (v.options || [])[Number(b.dataset.optIndex)] === b.dataset.optValue;
          b.setAttribute('aria-pressed', on);
          b.setAttribute('aria-checked', on);
        });
        this.querySelectorAll('[data-opt-label]').forEach((el) => (el.textContent = (v.options || [])[Number(el.dataset.optLabel)] || ''));
        this.querySelectorAll('[data-opt-select]').forEach((sel) => (sel.value = (v.options || [])[Number(sel.dataset.optSelect)] || sel.value));
      }

      buildFields() {
        const box = this.querySelector('[data-fields]');
        this.def.fields.forEach((f) => {
          const label = document.createElement('label');
          label.className = 'ideo-field';
          const head = document.createElement('span');
          head.className = 'ideo-field__label';
          head.textContent = f.label;
          let input;
          if (f.type === 'images' && this.def.livre) return this.buildLivrePhotos(box, f);
          if (f.type === 'fil') return this.buildThread(box, f);
          if (f.type === 'images') {
            // calendrier : un vrai bouton d'envoi, la progression et une bande de vignettes (une par page)
            const wrap = document.createElement('div');
            wrap.className = 'ideo-field ideo-field--file ideo-photos';
            head.textContent = 'Vos photos';
            const count = document.createElement('span');
            count.dataset.photoCount = '';
            head.appendChild(count);
            input = document.createElement('input');
            input.type = 'file';
            input.multiple = true;
            input.accept = 'image/jpeg,image/png,image/heic,image/webp';
            input.hidden = true;
            input.addEventListener('change', () => {
              this.loadPhotos(f, [...input.files], this.firstEmptySlot());
              input.value = '';
            });
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'ideo-btn ideo-btn--dark ideo-photos__add';
            btn.dataset.photoAdd = '';
            btn.addEventListener('click', () => input.click());
            const bar = document.createElement('div');
            bar.className = 'ideo-photos__bar';
            bar.innerHTML = '<span data-photo-bar></span>';
            const hint = document.createElement('small');
            hint.className = 'ideo-field__hint';
            hint.textContent = this.def.pages
              ? `Sélectionnez vos ${f.count} photos d'un coup : la 1re va en couverture, puis de janvier à décembre. En attendant, l'aperçu montre des photos d'exemple.`
              : `Sélectionnez vos ${f.count} photos d'un coup, dans l'ordre de la grille (de gauche à droite, puis de haut en bas). Touchez une vignette pour changer une photo.`;
            const strip = document.createElement('div');
            strip.className = 'ideo-strip';
            strip.dataset.slots = '';
            const act = document.createElement('div');
            act.className = 'ideo-photos__act';
            act.dataset.photoAct = '';
            wrap.append(head, btn, bar, strip, act, hint, input);
            box.appendChild(wrap);
            this.photoField = f;
            this.renderSlots();
            return;
          }
          if (f.type === 'image') {
            input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/jpeg,image/png,image/heic,image/webp';
            input.addEventListener('change', () => this.loadPhoto(f, input.files[0]));
            label.classList.add('ideo-field--file');
          } else if (f.type === 'textarea') {
            input = document.createElement('textarea');
            input.maxLength = f.max;
            input.rows = 3;
            input.value = this.values[f.key];
            const count = document.createElement('span');
            count.textContent = `${input.value.length}/${f.max}`;
            head.appendChild(count);
            input.addEventListener('input', () => (count.textContent = `${input.value.length}/${f.max}`));
          } else if (f.type === 'select') {
            input = document.createElement('select');
            f.options.forEach((o) => input.add(new Option(o, o, false, o === this.values[f.key])));
          } else {
            input = document.createElement('input');
            input.type = 'text';
            input.maxLength = f.max;
            input.value = this.values[f.key];
            const count = document.createElement('span');
            count.textContent = `${input.value.length}/${f.max}`;
            head.appendChild(count);
            input.addEventListener('input', () => (count.textContent = `${input.value.length}/${f.max}`));
          }
          input.className = 'ideo-input';
          input.name = f.key;
          input.required = !f.optional;
          if (f.type !== 'image') input.addEventListener('input', () => {
            this.values[f.key] = input.value.trim();
            this.draw();
          });
          label.append(head, input);
          if (f.hint) {
            const hint = document.createElement('small');
            hint.className = 'ideo-field__hint';
            hint.textContent = f.hint;
            label.appendChild(hint);
          }
          box.appendChild(label);
        });
      }

      /** Broderie : couleur de fil en pastilles (« Assorti » = fil foncé sur tissu clair, blanc sur tissu foncé). */
      buildThread(box, f) {
        const D = window.IdeoDesigns;
        const wrap = document.createElement('div');
        wrap.className = 'ideo-field ideo-fil';
        const head = document.createElement('span');
        head.className = 'ideo-field__label';
        head.textContent = `${f.label} `;
        const cur = document.createElement('span');
        cur.className = 'ideo-pdp__optval';
        head.appendChild(cur);
        const list = document.createElement('div');
        list.className = 'ideo-fil__list';
        list.setAttribute('role', 'radiogroup');
        list.setAttribute('aria-label', f.label);
        // « Assorti » : proposé si c'est le réglage du champ ou celui du produit (métachamp defaults)
        const opts = (f.default === 'auto' || this.values[f.key] === 'auto' ? [['auto', f.autoLabel || 'Assorti au tissu']] : []).concat(D.THREADS);
        const sync = () => {
          const v = this.values[f.key];
          cur.textContent = this.threadName(v, f);
          list.querySelectorAll('button').forEach((b) => b.setAttribute('aria-checked', b.dataset.fil === v));
        };
        opts.forEach(([hex, name]) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'ideo-fil__dot' + (hex === 'auto' ? ' ideo-fil__dot--auto' : '');
          b.dataset.fil = hex;
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-label', name);
          b.title = name;
          if (hex !== 'auto') b.style.setProperty('--fil', hex);
          b.addEventListener('click', () => {
            this.values[f.key] = hex;
            sync();
            this.draw();
            this.dispatchEvent(new CustomEvent('ideo:edit'));
          });
          list.appendChild(b);
        });
        wrap.append(head, list);
        box.appendChild(wrap);
        sync();
      }

      /** Nom lisible d'un fil (« auto » → fil choisi d'après la couleur du tissu). */
      threadName(v, f) {
        if (!v || v === 'auto') return (f && f.autoLabel) || 'Assorti au tissu';
        const t = window.IdeoDesigns.THREADS.find(([hex]) => hex === v);
        return t ? t[1] : v;
      }

      /** Fil pour le panier et la commande : « Assorti au tissu » précise le fil retenu (blanc sur tissu foncé). */
      threadLabel(v, f) {
        if ((!v || v === 'auto') && f && f.autoLabel) return f.autoLabel;
        return !v || v === 'auto' ? `Assorti au tissu (${this.values._dark ? 'blanc' : 'noir'})` : this.threadName(v, f);
      }

      /** Charge plusieurs photos (calendrier) à partir de la case `start`, redimensionnées pour ménager la mémoire. */
      async loadPhotos(field, files, start) {
        if (!files.length) return;
        this.values._images = this.values._images || [];
        let small = 0;
        this.message(`Chargement de ${files.length} photo(s)…`);
        for (let i = 0; i < files.length && start + i < field.count; i++) {
          try {
            const probe = await createImageBitmap(files[i], { imageOrientation: 'from-image' });
            if (Math.min(probe.width, probe.height) < 1200) small++;
            const k = Math.min(1, 2600 / Math.max(probe.width, probe.height));
            if (k < 1) {
              this.values._images[start + i] = await createImageBitmap(files[i], {
                imageOrientation: 'from-image',
                resizeWidth: Math.round(probe.width * k),
                resizeHeight: Math.round(probe.height * k),
                resizeQuality: 'high',
              });
              probe.close();
            } else {
              this.values._images[start + i] = probe;
            }
          } catch (e) {
            this.message(`Impossible de lire « ${files[i].name} ».`, true);
          }
        }
        this.values[field.key] = `${this.values._images.filter(Boolean).length} photo(s)`;
        this.message(small ? `${small} photo(s) un peu petite(s) : elles risquent d'être floues à l'impression.` : 'Photos ajoutées ✓', !!small);
        if (files.length === 1) this.values._page = start;
        this.renderSlots();
        this.syncPageNav();
        this.draw();
      }


      /* ---------- Livre photo : 30 à 141 photos, vignettes, pages ---------- */

      /** Nombre de pages de la variante choisie (style « rigide-30 » → 30). */
      livrePages() {
        return parseInt(String(this.shotStyle || 'rigide-30').split('-')[1], 10) || 30;
      }

      /** Champ photos du livre : bouton d'ajout (plusieurs à la fois), compteur, vignettes (couverture, retirer). */
      buildLivrePhotos(box, f) {
        this.livreField = f;
        this.livreFiles = [];
        this.values._images = [];
        const wrap = document.createElement('div');
        wrap.className = 'ideo-field ideo-field--file ideo-photos ideo-livre';
        wrap.innerHTML = `
          <span class="ideo-field__label">Vos photos <span data-livre-count></span></span>
          <button type="button" class="ideo-btn ideo-btn--dark ideo-photos__add" data-livre-add>Ajouter des photos</button>
          <div class="ideo-photos__bar"><span data-livre-bar></span></div>
          <div class="ideo-lgrid" data-livre-grid></div>
          <small class="ideo-field__hint" data-livre-hint></small>`;
        const input = document.createElement('input');
        input.type = 'file';
        input.multiple = true;
        input.accept = 'image/jpeg,image/png,image/heic,image/webp';
        input.hidden = true;
        input.addEventListener('change', () => {
          this.loadLivrePhotos([...input.files]);
          input.value = '';
        });
        wrap.appendChild(input);
        wrap.querySelector('[data-livre-add]').addEventListener('click', () => input.click());
        box.appendChild(wrap);
        // photo d'origine décodée à la demande pour le fichier d'impression (jamais toutes en mémoire en même temps)
        this.values._hires = async (i, px) => {
          const full = await createImageBitmap(this.livreFiles[i], { imageOrientation: 'from-image' });
          const k = Math.min(1, px / Math.max(full.width, full.height));
          if (k >= 1) return full;
          const out = await createImageBitmap(full, { resizeWidth: Math.round(full.width * k), resizeHeight: Math.round(full.height * k), resizeQuality: 'high' });
          full.close();
          return out;
        };
        this.renderLivreGrid();
      }

      async loadLivrePhotos(files) {
        if (!files.length) return;
        const [, max] = window.IdeoDesigns.livreRange(this.values, this.livrePages());
        const room = max - this.livreFiles.length;
        const take = files.slice(0, Math.max(0, room));
        let small = 0;
        for (let i = 0; i < take.length; i++) {
          this.message(`Chargement des photos : ${i + 1}/${take.length}…`);
          try {
            const full = await createImageBitmap(take[i], { imageOrientation: 'from-image' });
            if (Math.min(full.width, full.height) < 1200) small++;
            const k = Math.min(1, 520 / Math.max(full.width, full.height));
            const prev = k < 1
              ? await createImageBitmap(full, { resizeWidth: Math.round(full.width * k), resizeHeight: Math.round(full.height * k), resizeQuality: 'high' })
              : full;
            if (prev !== full) full.close();
            this.livreFiles.push(take[i]);
            this.values._images.push(prev);
          } catch (e) {
            this.message(`Impossible de lire « ${take[i].name} ».`, true);
          }
        }
        const skipped = files.length - take.length;
        this.values.photos = `${this.livreFiles.length} photo(s)`;
        this.renderLivreGrid();
        this.draw();
        if (skipped > 0) this.message(`${skipped} photo(s) en trop non ajoutée(s) : ce livre en accepte ${max} au maximum. Choisissez plus de pages pour en mettre davantage.`, true);
        else this.message(small ? `${small} photo(s) un peu petite(s) : elles risquent d'être floues à l'impression.` : 'Photos ajoutées ✓', !!small);
      }

      /** Déplace la photo i en tête (couverture) ou la retire. */
      livreMove(i, to) {
        const imgs = this.values._images, files = this.livreFiles;
        const [im] = imgs.splice(i, 1);
        const [fl] = files.splice(i, 1);
        if (to === 0) {
          imgs.unshift(im);
          files.unshift(fl);
        } else if (im && im.close) im.close();
        this.values.photos = files.length ? `${files.length} photo(s)` : '';
        this.renderLivreGrid();
        this.draw();
      }

      renderLivreGrid() {
        const grid = this.querySelector('[data-livre-grid]');
        if (!grid) return;
        const pages = this.livrePages();
        const [min, max] = window.IdeoDesigns.livreRange(this.values, pages);
        const n = this.livreFiles.length;
        this.querySelector('[data-livre-count]').textContent = `${n} / ${min} à ${max}`;
        this.querySelector('[data-livre-bar]').style.width = `${Math.min(100, (100 * n) / min)}%`;
        this.querySelector('[data-livre-add]').textContent = n === 0 ? `Ajouter vos photos (${min} à ${max})` : n < min ? `Ajouter encore ${min - n} photos au moins` : n < max ? 'Ajouter d’autres photos' : 'Le livre est complet ✓';
        this.querySelector('[data-livre-hint]').textContent = n < min
          ? `Pour ${pages} pages : au moins ${min} photos (la 1re va en couverture), jusqu'à ${max} (deux par page). Sélectionnez-les d'un coup, dans l'ordre. En attendant, l'aperçu montre des photos d'exemple.`
          : `La 1re photo va en couverture, les suivantes remplissent les pages dans l'ordre (une ou deux par page). Touchez ★ pour choisir la couverture, × pour retirer une photo.`;
        grid.replaceChildren();
        this.values._images.forEach((bmp, i) => {
          const cell = document.createElement('div');
          cell.className = 'ideo-lgrid__cell';
          const c = document.createElement('canvas');
          c.width = c.height = 96;
          const k = Math.max(96 / bmp.width, 96 / bmp.height);
          c.getContext('2d').drawImage(bmp, (96 - bmp.width * k) / 2, (96 - bmp.height * k) / 2, bmp.width * k, bmp.height * k);
          const cap = document.createElement('span');
          cap.textContent = i === 0 ? 'Couverture' : String(i);
          cell.append(c, cap);
          if (i > 0) {
            const star = document.createElement('button');
            star.type = 'button';
            star.className = 'ideo-lgrid__btn ideo-lgrid__btn--star';
            star.setAttribute('aria-label', `Mettre la photo ${i} en couverture`);
            star.textContent = '★';
            star.addEventListener('click', () => this.livreMove(i, 0));
            cell.appendChild(star);
          }
          const del = document.createElement('button');
          del.type = 'button';
          del.className = 'ideo-lgrid__btn';
          del.setAttribute('aria-label', `Retirer la photo ${i === 0 ? 'de couverture' : i}`);
          del.textContent = '×';
          del.addEventListener('click', () => this.livreMove(i, -1));
          cell.appendChild(del);
          grid.appendChild(cell);
        });
        if (this.syncLivreNav) this.syncLivreNav();
      }

      /** Aperçu du livre : vue « Couverture » ou « Pages » (double page, flèches, balayage). */
      buildLivreUI() {
        this.livreView = 'cover';
        this.values._page = 0;
        try {
          const urls = JSON.parse(this.querySelector('[data-samples]')?.textContent || '[]');
          this.livreSamples = [];
          urls.forEach((u, i) => {
            const img = new Image();
            img.addEventListener('load', () => {
              this.livreSamples[i] = img;
              this.draw();
            });
            img.src = u;
          });
        } catch (e) {}
        const stage = this.querySelector('.ideo-pdp__stage');
        const ui = document.createElement('div');
        ui.className = 'ideo-cal';
        ui.innerHTML = `
          <button type="button" class="ideo-cal__arrow ideo-cal__arrow--prev" data-livre-prev aria-label="Pages précédentes">‹</button>
          <button type="button" class="ideo-cal__arrow ideo-cal__arrow--next" data-livre-next aria-label="Pages suivantes">›</button>
          <span class="ideo-cal__sample" data-livre-sample hidden>Photos d'exemple</span>
          <div class="ideo-cal__bar">
            <span class="ideo-cal__label" data-livre-label></span>
            <span class="ideo-cal__views" role="group" aria-label="Type d'aperçu">
              <button type="button" data-livre-view="cover" aria-pressed="true">Couverture</button>
              <button type="button" data-livre-view="pages" aria-pressed="false">Pages</button>
            </span>
          </div>`;
        stage.appendChild(ui);
        const spreads = () => this.livrePages() / 2 + 1;
        const go = (d) => {
          if (this.livreView === 'cover') {
            if (d < 0) return;
            this.livreView = 'pages';
            this.values._page = 0;
          } else {
            const p = (this.values._page || 0) + d;
            if (p < 0) {
              this.livreView = 'cover';
              this.values._page = 0;
            } else this.values._page = Math.min(spreads() - 1, p);
          }
          this.syncLivreNav();
          this.draw();
        };
        ui.querySelector('[data-livre-prev]').addEventListener('click', () => go(-1));
        ui.querySelector('[data-livre-next]').addEventListener('click', () => go(1));
        ui.querySelectorAll('[data-livre-view]').forEach((b) =>
          b.addEventListener('click', () => {
            this.livreView = b.dataset.livreView;
            this.values._page = 0;
            this.syncLivreNav();
            this.draw();
          })
        );
        let x0 = null;
        stage.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
        stage.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
          x0 = null;
        });
        this.syncLivreNav = () => {
          const pages = this.livrePages();
          const p = this.values._page || 0;
          ui.querySelectorAll('[data-livre-view]').forEach((x) => x.setAttribute('aria-pressed', x.dataset.livreView === this.livreView));
          ui.querySelector('[data-livre-label]').textContent = this.livreView === 'cover' ? 'Couverture'
            : p === 0 ? 'Page 1' : p >= spreads() - 1 ? `Page ${pages}` : `Pages ${2 * p} et ${2 * p + 1}`;
          const [min] = window.IdeoDesigns.livreRange(this.values, pages);
          ui.querySelector('[data-livre-sample]').hidden = (this.livreFiles || []).length >= min;
        };
        this.syncLivreNav();
      }

      /** Pastille « Photo d'exemple » sur l'aperçu d'un tableau photo tant que le client n'a pas mis sa photo. */
      showSampleBadge(on) {
        if (this.format !== 'tableau') return;
        let b = this.querySelector('[data-sample-badge]');
        if (!b && on) {
          const stage = this.querySelector('.ideo-pdp__stage');
          if (!stage) return;
          b = document.createElement('span');
          b.className = 'ideo-cal__sample';
          b.dataset.sampleBadge = '';
          b.textContent = "Photo d'exemple";
          stage.appendChild(b);
        }
        if (b) b.hidden = !on;
      }

      /** Photos d'exemple de l'aperçu (jamais imprimées) : calendrier, collages. */
      loadSamples() {
        let urls = [];
        try {
          urls = JSON.parse(this.querySelector('[data-samples]')?.textContent || '[]');
        } catch (e) {}
        // photo unique (tableau photo) : une photo d'exemple dans l'aperçu tant que le client n'a pas mis la sienne
        const one = this.querySelector('[data-sample]');
        if (one && !this.photoField) {
          try {
            const img = new Image();
            img.addEventListener('load', () => {
              this.sampleImage = img;
              this.draw();
            });
            img.src = JSON.parse(one.textContent);
          } catch (e) {}
        }
        if (!urls.length || !this.photoField) return;
        this.samples = [];
        urls.slice(0, this.photoField.count).forEach((u, i) => {
          const img = new Image();
          img.addEventListener('load', () => {
            this.samples[i] = img;
            this.draw();
          });
          img.src = u;
        });
      }

      /** Nom d'une case photo : « Photo 2 » (collage) ou « Mars » (calendrier). */
      slotName(i) {
        return (this.photoField.labels && this.photoField.labels[i]) || PAGE_NAMES[i];
      }

      firstEmptySlot() {
        const imgs = this.values._images || [];
        for (let i = 0; i < this.photoField.count; i++) if (!imgs[i]) return i;
        return 0;
      }

      pickPhoto(i) {
        const pick = document.createElement('input');
        pick.type = 'file';
        pick.accept = 'image/jpeg,image/png,image/heic,image/webp';
        pick.addEventListener('change', () => this.loadPhotos(this.photoField, [...pick.files].slice(0, 1), i));
        pick.click();
      }

      /** Bande de vignettes (Couverture, Janv.…) : toucher une vignette affiche sa page ; une case vide ouvre le choix de photo. */
      renderSlots() {
        const strip = this.querySelector('[data-slots]');
        if (!strip || !this.photoField) return;
        const n = this.photoField.count;
        const imgs = this.values._images || [];
        const done = imgs.filter(Boolean).length;
        const page = this.values._page || 0;
        this.querySelector('[data-photo-count]').textContent = `${done} / ${n}`;
        this.querySelector('[data-photo-bar]').style.width = `${(100 * done) / n}%`;
        this.querySelector('[data-photo-add]').textContent =
          done === 0 ? `Ajouter vos ${n} photos` : done < n ? `Ajouter les ${n - done} photos manquantes` : 'Toutes vos photos sont ajoutées ✓';
        strip.replaceChildren();
        for (let i = 0; i < n; i++) {
          const slot = document.createElement('button');
          slot.type = 'button';
          slot.className = 'ideo-slot';
          slot.setAttribute('aria-pressed', i === page);
          slot.setAttribute('aria-label', `${this.slotName(i)} : ${imgs[i] ? 'afficher' : 'ajouter une photo'}`);
          const bmp = imgs[i];
          if (bmp) {
            const c = document.createElement('canvas');
            c.width = 112;
            c.height = 84;
            const k = Math.max(112 / bmp.width, 84 / bmp.height);
            c.getContext('2d').drawImage(bmp, (112 - bmp.width * k) / 2, (84 - bmp.height * k) / 2, bmp.width * k, bmp.height * k);
            slot.appendChild(c);
          } else {
            slot.classList.add('is-empty');
          }
          const cap = document.createElement('span');
          cap.textContent = (this.photoField.labels && this.photoField.labels[i]) || PAGE_LABELS[i] || String(i);
          slot.appendChild(cap);
          slot.addEventListener('click', () => {
            this.values._page = i;
            this.renderSlots();
            this.syncPageNav();
            this.draw();
            if (!imgs[i]) this.pickPhoto(i);
          });
          strip.appendChild(slot);
        }
        const sel = strip.children[Math.min(page, n - 1)];
        if (sel) strip.scrollTo({ left: sel.offsetLeft - strip.clientWidth / 2 + sel.clientWidth / 2, behavior: 'smooth' });
        // action sur la page affichée : remplacer sa photo
        const act = this.querySelector('[data-photo-act]');
        act.replaceChildren();
        if (page < n && imgs[page]) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'ideo-linkbtn';
          b.textContent = `Remplacer la photo : ${this.slotName(page).toLowerCase()}`;
          b.addEventListener('click', () => this.pickPhoto(page));
          act.appendChild(b);
        }
      }

      /** Carte : vraie carte Gelato (recto en perspective) ou vue à plat « Intérieur » ; rendu selon le format A6 / A5. */
      buildCardUI() {
        this.cardView = 'card';
        const load = (src) => {
          const i = new Image();
          i.addEventListener('load', () => this.draw());
          i.src = src;
          return i;
        };
        this.cardMocks = {};
        ['a6', 'a5'].forEach((sz) => {
          const photo = this.dataset[`card${sz.toUpperCase()}`];
          const mask = this.dataset[`card${sz.toUpperCase()}Mask`];
          if (photo && mask) this.cardMocks[sz] = { size: sz, photo: null, mask: null, src: [photo, mask] };
        });
        this.cardMock = () => {
          const sz = this.shotStyle === 'a5' ? 'a5' : 'a6';
          const m = this.cardMocks[sz];
          if (!m) return null;
          if (!m.photo) {
            m.photo = load(m.src[0]);
            m.mask = load(m.src[1]);
          }
          return m;
        };
        const stage = this.querySelector('.ideo-pdp__stage');
        const ui = document.createElement('div');
        ui.className = 'ideo-cal ideo-cardui';
        ui.innerHTML = `
          <div class="ideo-cal__bar">
            <span></span>
            <span class="ideo-cal__views" role="group" aria-label="Type d'aperçu">
              <button type="button" data-card-view="card" aria-pressed="true">Carte</button>
              <button type="button" data-card-view="inside" aria-pressed="false">Recto et intérieur</button>
            </span>
          </div>`;
        stage.appendChild(ui);
        ui.querySelectorAll('[data-card-view]').forEach((b) =>
          b.addEventListener('click', () => {
            this.cardView = b.dataset.cardView;
            ui.querySelectorAll('[data-card-view]').forEach((x) => x.setAttribute('aria-pressed', x === b));
            this.draw();
          })
        );
      }

      /** Calendrier : photos d'exemple, flèches page précédente / suivante, nom de la page, vue « page » ou « au mur ». */
      buildCalendarUI() {
        this.calView = 'flat';
        this.values._page = 0;
        const stage = this.querySelector('.ideo-pdp__stage');
        const ui = document.createElement('div');
        ui.className = 'ideo-cal';
        ui.innerHTML = `
          <button type="button" class="ideo-cal__arrow ideo-cal__arrow--prev" data-cal-prev aria-label="Page précédente">‹</button>
          <button type="button" class="ideo-cal__arrow ideo-cal__arrow--next" data-cal-next aria-label="Page suivante">›</button>
          <div class="ideo-cal__bar">
            <span class="ideo-cal__label" data-cal-label></span>
            <span class="ideo-cal__views" role="group" aria-label="Type d'aperçu">
              <button type="button" data-cal-view="flat" aria-pressed="true">Page</button>
              <button type="button" data-cal-view="wall" aria-pressed="false">Au mur</button>
            </span>
          </div>
          <span class="ideo-cal__sample" data-cal-sample hidden>Photo d'exemple</span>`;
        stage.appendChild(ui);
        const go = (d) => {
          const total = this.def.pages;
          this.values._page = ((this.values._page || 0) + d + total) % total;
          this.syncPageNav();
          this.renderSlots();
          this.draw();
        };
        ui.querySelector('[data-cal-prev]').addEventListener('click', () => go(-1));
        ui.querySelector('[data-cal-next]').addEventListener('click', () => go(1));
        ui.querySelectorAll('[data-cal-view]').forEach((b) =>
          b.addEventListener('click', () => {
            this.calView = b.dataset.calView;
            ui.querySelectorAll('[data-cal-view]').forEach((x) => x.setAttribute('aria-pressed', x === b));
            this.draw();
          })
        );
        // balayage gauche / droite sur l'aperçu (mobile)
        let x0 = null;
        stage.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
        stage.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
          x0 = null;
        });
        this.syncPageNav();
      }

      syncPageNav() {
        const label = this.querySelector('[data-cal-label]');
        if (!label) return;
        const p = this.values._page || 0;
        const year = parseInt(this.values.annee, 10) || '';
        label.textContent = p >= 1 && p <= 12 ? `${PAGE_NAMES[p]} ${year}` : PAGE_NAMES[p];
      }

      /** Charge la photo du client (orientation EXIF respectée) et vérifie sa définition. */
      async loadPhoto(field, file) {
        if (!file) return;
        try {
          const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
          this.values._image = bitmap;
          this.values[field.key] = file.name;
          const min = Math.min(bitmap.width, bitmap.height);
          const needed = this.format === 'poster' ? 2400 : this.format === 'tableau' ? 1800 : 1000;
          // tableau photo : l'orientation suit celle de la photo (le client peut la rechanger)
          if (this.format === 'tableau' && this.pickOption) {
            const want = bitmap.width > bitmap.height * 1.05 ? 'Paysage' : bitmap.height > bitmap.width * 1.05 ? 'Portrait' : null;
            const cur = (this.variants.find((x) => x.id === Number(this.dataset.variant)) || {}).options || [];
            if (want && cur[2] && cur[2] !== want) this.pickOption(2, want);
          }
          this.message(
            min < needed
              ? `Photo un peu petite (${bitmap.width}×${bitmap.height} px) : l'impression risque d'être floue. Choisissez si possible l'original.`
              : 'Photo ajoutée ✓'
          , min < needed);
          this.draw();
        } catch (e) {
          this.message('Impossible de lire cette photo. Essayez un fichier JPG ou PNG.', true);
        }
      }

      draw() {
        if (!this.canvas) return;
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => {
          let values = this.values;
          if (this.samples) {
            // aperçu : vos photos, complétées par les photos d'exemple (jamais envoyées à l'impression)
            const mine = this.values._images || [];
            const n = this.photoField ? this.photoField.count : 13;
            values = { ...this.values, _images: Array.from({ length: n }, (_, i) => mine[i] || this.samples[i] || null) };
            const p = this.values._page || 0;
            const badge = this.querySelector('[data-cal-sample]');
            if (badge) badge.hidden = p >= n || !!mine[p];
            this.querySelector('.ideo-pdp__stage').classList.toggle('is-portrait', this.calView === 'flat');
          }
          if (this.sampleImage && !this.values._image) values = { ...values, _image: this.sampleImage };
          if (this.def.livre) values = { ...values, _samples: (this.livreSamples || []).filter(Boolean) };
          this.showSampleBadge(!!(this.sampleImage && !this.values._image) || (this.format === 'tableau' && !!this.samples && !(this.values._images || []).some(Boolean)));
          window.IdeoDesigns.drawShot(this.canvas, {
            design: this.design, format: this.format, values, mockup: this.mockup, style: this.shotStyle,
            zoom: { mug: 1, tote: 1.6, tshirt: 1.35, body: 1.7, sweat: 1.35, enfant: 1.35, gourde: 1.9, coque: 1.2, brode: 1.35 }[this.format], print: this.printFormat, view: this.def.livre ? this.livreView : this.format === 'card' ? this.cardView : this.calView, spiral: this.spiral, cardMock: this.cardMock ? this.cardMock() : null, garmentMask: this.garmentMask,
          });
          this.querySelector('.ideo-pdp__stage').classList.add('is-live');
          this.dispatchEvent(new CustomEvent('ideo:drawn'));
        });
      }

      message(text, isError) {
        const msg = this.querySelector('[data-msg]');
        msg.textContent = text;
        msg.classList.toggle('is-error', !!isError);
      }

      /** Génère le fichier d'impression HD et l'envoie au relais ; renvoie son URL (ou null sans relais). */
      async uploadPrintFile() {
        const relay = (this.dataset.relay || '').replace(/\/$/, '');
        if (!relay) return null;
        // fichier d'impression : illustrations en haute définition
        if (window.IdeoDesigns.prepare) await window.IdeoDesigns.prepare(this.design, true);
        let blob;
        if (this.def.livre) {
          blob = await window.IdeoDesigns.renderLivrePdf(this.design, this.values, this.shotStyle, (n, total) =>
            this.message(`Préparation du livre : page ${n}/${total}…`)
          );
        } else if (this.def.pages) {
          blob = await window.IdeoDesigns.renderPdf(this.design, this.printFormat || this.format, this.values, (n, total) =>
            this.message(`Préparation du fichier d’impression : page ${n}/${total}…`)
          );
        } else {
          const canvas = window.IdeoDesigns.renderPrint(this.design, this.printFormat || this.format, this.values);
          // broderie : fils réellement utilisés par le fichier (envoyés à Gelato en threadColors)
          this.threads = canvas.threads || null;
          blob = await new Promise((r) => canvas.toBlob(r, 'image/png'));
        }
        this.message('Envoi du fichier d’impression…');
        const res = await fetch(`${relay}/upload`, { method: 'POST', headers: { 'Content-Type': blob.type }, body: blob });
        if (!res.ok) throw new Error('upload');
        return (await res.json()).url;
      }


      /** Petite image de l'aperçu en direct (480 px) pour la vignette du panier ; jamais bloquante. */
      async uploadPreview() {
        const relay = (this.dataset.relay || '').replace(/\/$/, '');
        if (!relay || !this.canvas || !this.canvas.width) return null;
        try {
          const k = Math.min(1, 480 / Math.max(this.canvas.width, this.canvas.height));
          const c = document.createElement('canvas');
          c.width = Math.round(this.canvas.width * k);
          c.height = Math.round(this.canvas.height * k);
          c.getContext('2d').drawImage(this.canvas, 0, 0, c.width, c.height);
          const blob = await new Promise((r) => c.toBlob(r, 'image/png'));
          const res = await fetch(`${relay}/upload`, { method: 'POST', headers: { 'Content-Type': 'image/png' }, body: blob });
          return res.ok ? (await res.json()).url : null;
        } catch (e) {
          return null;
        }
      }

      /* ---------- Pack « à offrir aussi » : produit jumeau avec la même personnalisation ---------- */

      /** Champs repris sur le produit jumeau : même design, et même valeur par défaut des deux côtés (prénoms, date…) ;
          les champs de rôle (« Mamie » / « Papy ») gardent la valeur du jumeau. */
      packCarried() {
        const p = this.pack;
        if (!p || p.design !== this.design) return {};
        const md = p.defaults || {};
        const out = {};
        // liste explicite (data/set_packs.py) : prénoms, signature… ; sinon les champs de même valeur par défaut
        if (Array.isArray(p.carry)) {
          p.carry.forEach((k) => {
            if (this.values[k] !== undefined) out[k] = this.values[k];
          });
          return out;
        }
        this.def.fields.forEach((f) => {
          if (f.type === 'image' || f.type === 'images') return;
          const mine = this.productDefaults[f.key] !== undefined ? this.productDefaults[f.key] : f.default;
          const theirs = md[f.key] !== undefined ? md[f.key] : f.default;
          if (mine === theirs && this.values[f.key] !== undefined) out[f.key] = this.values[f.key];
        });
        return out;
      }

      /** Variante du jumeau : mêmes options que la variante choisie ici si elles existent (modèle de mug, format…). */
      packVariant() {
        const cur = (this.variants.find((x) => x.id === Number(this.dataset.variant)) || {}).options || [];
        const vs = (this.pack.variants || []).filter((v) => v.available);
        return vs.find((v) => (v.options || []).join('|') === cur.join('|')) || vs[0];
      }

      buildPack() {
        const box = this.querySelector('[data-pack]');
        if (!box) return;
        try {
          this.pack = JSON.parse(box.querySelector('[data-pack-data]').textContent);
          if (typeof this.pack.defaults === 'string') this.pack.defaults = JSON.parse(this.pack.defaults);
          if (typeof this.pack.formats === 'string') this.pack.formats = JSON.parse(this.pack.formats);
        } catch (e) {
          box.hidden = true;
          return;
        }
        const money = (c) => `${(c / 100).toFixed(2).replace('.', ',')} €`;
        this.syncPack = () => {
          const mv = this.packVariant();
          const cur = this.variants.find((x) => x.id === Number(this.dataset.variant)) || {};
          const el = box.querySelector('[data-pack-price]');
          if (!mv || !cur.cents) return (el.textContent = '');
          const total = cur.cents + mv.cents;
          const pack = total - Math.round(Math.min(cur.cents, mv.cents) * 0.15);
          el.innerHTML = this.pack.mode === 'add'
            ? `Les deux : <strong>${money(pack)}</strong> <s>${money(total)}</s>`
            : `-15 % sur le 2e article, appliqué au panier`;
          const names = Object.values(this.packCarried()).filter((x) => typeof x === 'string' && x.trim()).join(' · ');
          box.querySelector('[data-pack-desc]').textContent = names ? `${this.pack.title}, avec : ${names}` : this.pack.title;
        };
        this.syncPack();
        this.querySelector('[data-form]').addEventListener('input', () => this.syncPack());
        box.querySelector('[data-pack-add]').addEventListener('click', () => {
          if (this.pack.mode === 'add') return this.addToCart(true);
          // fiche jumelle pré-remplie : la personnalisation voyage dans l'adresse (?perso=…)
          const q = encodeURIComponent(JSON.stringify(this.packCarried()));
          window.location.href = `${this.pack.url}?perso=${q}`;
        });
      }

      /** Article du panier pour le produit jumeau (mode « add ») : son propre fichier d'impression, même personnalisation. */
      async packItem() {
        const D = window.IdeoDesigns;
        const p = this.pack;
        const pdef = D.DESIGNS[p.design];
        const mv = this.packVariant();
        const f = (p.formats || {})[(mv.options || []).join(' / ')] || (p.formats || {})[mv.option] || {};
        const vals = {};
        pdef.fields.forEach((fl) => (vals[fl.key] = (p.defaults || {})[fl.key] !== undefined ? p.defaults[fl.key] : fl.default));
        Object.assign(vals, this.packCarried());
        if (f.dark) vals._dark = true;
        const printFormat = f.print || p.format;
        const properties = {};
        pdef.fields.forEach((fl) => {
          if (vals[fl.key]) properties[fl.label] = vals[fl.key];
        });
        properties._design = p.design;
        properties._format = printFormat;
        properties._gelato_uid = f.uid || p.gelato;
        properties._values = JSON.stringify(vals);
        properties._pack = this.dataset.handle || '';
        const relay = (this.dataset.relay || '').replace(/\/$/, '');
        if (relay) {
          if (D.prepare) await D.prepare(p.design, true);
          const canvas = D.renderPrint(p.design, printFormat, vals);
          const blob = await new Promise((r) => canvas.toBlob(r, 'image/png'));
          canvas.width = canvas.height = 0;
          const res = await fetch(`${relay}/upload`, { method: 'POST', headers: { 'Content-Type': blob.type }, body: blob });
          if (!res.ok) throw new Error('upload');
          properties._print_file = (await res.json()).url;
        }
        return { id: mv.id, quantity: 1, properties };
      }

      async addToCart(withPack) {
        const empty = this.def.fields.find((f) =>
          f.type === 'image' ? !this.values._image : f.type === 'images' ? !(this.values._images || []).some(Boolean) : !f.optional && !String(this.values[f.key] || '').trim()
        );
        if (empty) return this.message(f_label(empty), true);
        const proof = this.querySelector('[data-proof]');
        if (proof && !proof.checked) {
          proof.closest('label').classList.add('is-error');
          proof.focus();
          return this.message('Cochez la case de relecture : prénoms, dates et orthographe seront imprimés tels quels.', true);
        }
        if (this.def.livre) {
          const pages = this.livrePages();
          const [min, max] = window.IdeoDesigns.livreRange(this.values, pages);
          const n = (this.livreFiles || []).length;
          if (n < min) return this.message(`Il manque ${min - n} photo(s) : il en faut au moins ${min} pour ${pages} pages (la 1re va en couverture).`, true);
          if (n > max) return this.message(`${n - max} photo(s) en trop : ${max} au maximum pour ${pages} pages. Retirez-en ou choisissez plus de pages.`, true);
        }
        if (this.photoField) {
          const imgs = this.values._images || [];
          const missing = Array.from({ length: this.photoField.count }, (_, i) => this.slotName(i)).filter((_, i) => !imgs[i]);
          if (missing.length) {
            this.values._page = this.firstEmptySlot();
            this.renderSlots();
            this.syncPageNav();
            this.draw();
            return this.message(
              missing.length === 1 ? `Il manque la photo : ${missing[0].toLowerCase()}.` : `Il manque ${missing.length} photos : ${missing.join(', ').toLowerCase()}.`,
              true
            );
          }
        }
        const btn = this.querySelector(withPack ? '[data-pack-add]' : '[data-add]');
        btn.disabled = true;
        this.message(withPack ? 'Préparation de vos deux fichiers d\'impression…' : 'Préparation de votre fichier d\'impression…');
        try {
          const properties = {};
          this.def.fields.forEach((f) => {
            if (this.values[f.key]) properties[f.label] = f.type === 'fil' ? this.threadLabel(this.values[f.key], f) : this.values[f.key];
          });
          // propriétés cachées (préfixe « _ ») lues par le relais de commandes
          properties._design = this.design;
          properties._format = this.printFormat || this.format;
          properties._gelato_uid = this.dataset.gelato;
          const { _image, _images, _page, _hires, _samples, ...plain } = this.values;
          properties._values = JSON.stringify(plain);
          const preview = this.uploadPreview();
          const url = await this.uploadPrintFile();
          if (url) properties._print_file = url;
          const previewUrl = await preview;
          if (previewUrl) properties._preview = previewUrl;
          if (this.threads && this.threads.length) properties._threads = this.threads.join(',');
          const qty = Math.max(1, parseInt(this.querySelector('[data-qty]').value, 10) || 1);
          const root = window.Shopify?.routes?.root || '/';
          const edit = new URLSearchParams(window.location.search).get('edit');
          let oldFile = null;
          if (edit) {
            const cart = await (await fetch(`${root}cart.js`)).json().catch(() => ({ items: [] }));
            const old = (cart.items || []).find((i) => i.key === edit);
            oldFile = old && old.properties && old.properties._print_file;
          }
          const res = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(this.dataset.variant), quantity: qty, properties }].concat(withPack ? [await this.packItem()] : []) }),
          });
          if (!res.ok) throw new Error('cart');
          // « Modifier » depuis le panier (?edit=<clé de ligne>) : l'ancien article est remplacé par le nouveau.
          // La clé d'une ligne change quand la remise s'applique : l'ancien article est retrouvé par son fichier d'impression.
          if (oldFile) try {
            const cart = await (await fetch(`${root}cart.js`)).json();
            const old = cart.items.find((i) => (i.properties || {})._print_file === oldFile);
            if (old) {
              await fetch(`${root}cart/change.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: old.key, quantity: 0 }),
              });
            }
          } catch (e) { /* l'ancien article reste au panier : le client peut le retirer */ }
          window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
        } catch (e) {
          btn.disabled = false;
          this.message('Oups, l\'ajout au panier a échoué. Réessayez dans un instant.', true);
        }
      }
    }
  );
}

/* Galerie de la fiche produit : « Votre aperçu » (canvas en direct) + photos du produit, sans quitter la page.
   Vignette → image principale ; clic sur l'image → visionneuse plein écran (flèches, clavier, balayage, zoom). */
if (!customElements.get('ideo-gallery')) {
  customElements.define(
    'ideo-gallery',
    class extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('[data-stage]');
        this.photo = this.querySelector('[data-photo]');
        this.canvas = this.querySelector('[data-canvas]');
        this.thumbs = [...this.querySelectorAll('[data-thumb]')];
        this.mini = this.querySelector('[data-live-mini]');
        this.box = this.querySelector('[data-lightbox]');
        this.current = this.canvas ? 'live' : 0;
        this.thumbs.forEach((t) => {
          t.addEventListener('click', () => this.show(t.dataset.thumb === 'live' ? 'live' : Number(t.dataset.thumb)));
          t.addEventListener('pointerenter', () => this.preload(), { once: true });
        });
        this.stage.addEventListener('click', (e) => {
          if (e.target.closest('[data-cal-sample], button, a')) return;
          this.open();
        });
        this.swipe(this.stage, (dir) => this.step(dir));
        // aperçu redessiné : mise à jour de la mini-vignette ; saisie du client : retour à l'aperçu
        const pdp = this.closest('ideo-product');
        if (pdp) {
          pdp.addEventListener('ideo:drawn', () => this.updateMini());
          pdp.addEventListener('ideo:edit', () => this.canvas && this.current !== 'live' && this.show('live'));
        }
        if (this.box) this.setupLightbox();
        if (!this.canvas && this.thumbs.length) this.show(0);
      }

      items() {
        return this.thumbs.map((t) => (t.dataset.thumb === 'live' ? 'live' : Number(t.dataset.thumb)));
      }

      thumb(i) {
        return this.thumbs.find((x) => x.dataset.thumb === String(i));
      }

      src(i, big) {
        if (i === 'live') return this.canvas.toDataURL('image/jpeg', 0.92);
        const t = this.thumb(i);
        return big ? t.dataset.full : t.dataset.src;
      }

      alt(i) {
        return i === 'live' ? 'Aperçu de votre personnalisation' : this.thumb(i)?.dataset.alt || '';
      }

      show(i) {
        this.current = i;
        this.thumbs.forEach((t) => t.setAttribute('aria-current', String(t.dataset.thumb === String(i))));
        const live = i === 'live';
        if (live) {
          this.stage.classList.remove('is-photo');
        } else {
          // on garde l'image affichée tant que la nouvelle photo n'est pas chargée
          const src = this.src(i);
          const next = new Image();
          next.onload = () => {
            if (this.current !== i) return;
            this.photo.src = src;
            this.photo.alt = this.alt(i);
            this.stage.classList.add('is-photo');
          };
          next.src = src;
          this.preload();
        }
        const strip = this.thumb(i)?.parentElement;
        const t = this.thumb(i);
        if (strip && t) strip.scrollTo({ left: t.offsetLeft - strip.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
      }

      preload() {
        if (this.preloaded) return;
        this.preloaded = true;
        this.thumbs.forEach((t) => t.dataset.src && (new Image().src = t.dataset.src));
      }

      step(dir) {
        const list = this.items();
        this.show(list[(list.indexOf(this.current) + dir + list.length) % list.length]);
      }

      updateMini() {
        if (!this.mini || !this.canvas || !this.canvas.width) return;
        const ctx = this.mini.getContext('2d');
        const s = Math.max(this.mini.width / this.canvas.width, this.mini.height / this.canvas.height);
        const w = this.canvas.width * s;
        const h = this.canvas.height * s;
        ctx.drawImage(this.canvas, (this.mini.width - w) / 2, (this.mini.height - h) / 2, w, h);
      }

      swipe(el, cb) {
        let x0 = null;
        let y0 = null;
        el.addEventListener('touchstart', (e) => {
          x0 = e.touches[0].clientX;
          y0 = e.touches[0].clientY;
        }, { passive: true });
        el.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0;
          const dy = e.changedTouches[0].clientY - y0;
          x0 = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
            this.swiped = true;
            setTimeout(() => (this.swiped = false), 350);
            cb(dx < 0 ? 1 : -1);
          }
        });
      }

      setupLightbox() {
        const img = this.box.querySelector('[data-lb-img]');
        const count = this.box.querySelector('[data-lb-count]');
        const render = () => {
          img.classList.remove('is-zoom');
          img.src = this.src(this.lbIndex, true);
          img.alt = this.alt(this.lbIndex);
          const list = this.items();
          count.textContent = `${list.indexOf(this.lbIndex) + 1} / ${list.length}`;
        };
        this.lbGo = (dir) => {
          const list = this.items();
          this.lbIndex = list[(list.indexOf(this.lbIndex) + dir + list.length) % list.length];
          render();
        };
        this.lbRender = render;
        this.box.querySelector('[data-lb-prev]').addEventListener('click', () => this.lbGo(-1));
        this.box.querySelector('[data-lb-next]').addEventListener('click', () => this.lbGo(1));
        this.box.querySelector('[data-lb-close]').addEventListener('click', () => this.box.close());
        this.box.addEventListener('click', (e) => e.target === this.box && this.box.close());
        this.box.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.lbGo(-1);
          if (e.key === 'ArrowRight') this.lbGo(1);
        });
        this.box.addEventListener('close', () => {
          document.documentElement.style.overflow = '';
          this.show(this.lbIndex);
        });
        // zoom : clic ou toucher → ×2,2 autour du point visé, qui suit ensuite la souris
        const origin = (e) => {
          const r = img.getBoundingClientRect();
          img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
        };
        img.addEventListener('click', (e) => {
          if (this.swiped) return;
          origin(e);
          img.classList.toggle('is-zoom');
        });
        img.addEventListener('mousemove', (e) => img.classList.contains('is-zoom') && origin(e));
        this.swipe(img, (dir) => !img.classList.contains('is-zoom') && this.lbGo(dir));
      }

      open() {
        if (!this.box || this.swiped) return;
        this.lbIndex = this.current;
        this.lbRender();
        document.documentElement.style.overflow = 'hidden';
        this.box.showModal();
      }
    }
  );
}
